import { render, staticRenderFns } from "./WelcomeOptions.vue?vue&type=template&id=811c5b32&scoped=true&"
import script from "./WelcomeOptions.vue?vue&type=script&lang=js&"
export * from "./WelcomeOptions.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeOptions.vue?vue&type=style&index=0&id=811c5b32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "811c5b32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('811c5b32')) {
      api.createRecord('811c5b32', component.options)
    } else {
      api.reload('811c5b32', component.options)
    }
    module.hot.accept("./WelcomeOptions.vue?vue&type=template&id=811c5b32&scoped=true&", function () {
      api.rerender('811c5b32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/WelcomeOptions.vue"
export default component.exports